// @flow
import type { StoreResourceDef } from 'app/core/types'

export const teams: StoreResourceDef<> = {
  resourceType: 'teams',
}
